import type {Handler} from './Handler';

type CacheDataType<T> = {
    url: string;
    promise: Promise<T[]>;
};
/**
 *
 *
 * @export
 * @class CacheHandler
 * @implements {Handler<T>}
 */
export default class CacheHandler<T> implements Handler<T> {
    resetCache = false;
    handler: Handler<T>;
    static cacheDataArray: CacheDataType<unknown>[] = [];
    url: string;
    objectProcessor: (object: object) => T;

    /**
     * Creates an instance of IDBHandler.
     * @param {string} url
     * @param {ObjectProcessor} objectProcessor
     * @memberof IDBHandler
     */
    constructor(url: string, objectProcessor: (data: object) => T) {
        this.url = url;
        this.objectProcessor = objectProcessor;
    }

    /**
     *
     *
     * @static
     * @return {*}  {(Promise<any> | void)}
     * @memberof CacheHandler
     */
    getCache(): Promise<T[]> | null {
        const networkRequest = CacheHandler.cacheDataArray.find(
            (cacheData: CacheDataType<T>) => cacheData.url === this.url
        );

        if (networkRequest) {
            return networkRequest.promise as Promise<T[]>;
        }

        return null;
    }

    /**
     *
     *
     * @memberof CacheHandler
     */
    deleteCache<T>(): void {
        CacheHandler.cacheDataArray = CacheHandler.cacheDataArray.filter(
            (cacheData: CacheDataType<T>) => cacheData.url !== this.url
        );
    }

    /**
     *
     * @param {Promise<any>} promise
     * @memberof CacheHandler
     */
    setCache(promise: Promise<T[]>): void {
        CacheHandler.cacheDataArray.push({
            url: this.url,
            promise,
        });
    }

    /**
     *
     *
     * @param {Handler<T>} handler
     * @return {*}  {Handler<T>}
     * @memberof CacheHandler
     */
    addHandler(handler: Handler<T>): Handler<T> {
        this.handler = handler;

        return handler;
    }

    /**
     *
     *
     * @param {boolean} resetCache
     * @memberof CacheHandler
     */
    setResetCache(resetCache: boolean) {
        this.resetCache = resetCache;
    }

    /**
     *
     *
     * @template T
     * @param {T} object
     * @return {*}  {Promise<Array<T>>}
     * @memberof HTTPHandler
     */
    getData(): Promise<T[]> {
        if (this.resetCache) {
            this.deleteCache();
        }

        let promise = this.getCache();

        try {
            if (promise == null) {
                promise = this.handler.getData();
                this.setCache(promise);
            }

            return promise;
        } catch (e) {
            this.deleteCache();
            throw e;
        }
    }

    /**
     *
     *
     * @param {T[]} data
     * @memberof HTTPHandler
     */
    setData() {
        // no impl
    }
}
